interface DraftContext {
    streamId?: string | null;
    flowId?: string | null;
}

export function leadStreamDraftKey(accountId: number, context: DraftContext = {}): string {
    if (!Number.isSafeInteger(accountId) || accountId <= 0) {
        throw new Error('An authenticated account is required to store a lead stream draft');
    }
    const ownerKey = `leadstream_selection:user:${accountId}`;
    if (context.streamId) return `${ownerKey}:stream:${encodeURIComponent(context.streamId)}`;
    if (context.flowId) return `${ownerKey}:flow:${encodeURIComponent(context.flowId)}`;
    return ownerKey;
}
